import styled from 'styled-components';
import {
    SEVERITY_LEVEL,
    SeverityLevel
} from '../shared/components/calculation/CalculationResult.types';
import { BLACK, DARK_GREEN, GREY1, RED } from '@swegon-core/uic/dist/src/theme';

interface SeveriteLevelProps {
    severitylevel: SeverityLevel;
}

export const WarningsAndErrorsTable = styled.table`
    font-family: 'SwegonBrown';
    font-size: 0.86em;
    font-weight: 100;
    border-collapse: collapse;
    width: 100%;
    margin-top: 20px;
    overflow-wrap: break-word;
`;

export const TableHeader = styled.thead`
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
`;

export const TableCellHeader = styled.th`
    padding: 0.5em;
    border-bottom: 1px solid ${DARK_GREEN};
    text-align: left;
    line-height: 1.4;
`;

export const WarningsRow = styled.tr`
    border-bottom: 1px solid ${GREY1};
`;

export const ComponentInfo = styled.th<SeveriteLevelProps>`
    display: table-cell;
    text-align: left;
    width: 20%;
    padding: 0.5em;
    color: ${(props) =>
        props.severitylevel === SEVERITY_LEVEL.ERROR ? `${RED}` : `${BLACK}`};
`;

export const WarningDescription = styled.td`
    display: table-cell;
    width: 75%;
    padding: 0.5em;
    text-align: left;
    line-height: 1.4;
`;

export const WarningIcon = styled.td`
    display: table-cell;
    text-align: center;
    padding: 0.3125em;
`;
